import { Box, Chip, Typography } from '@mui/material';
import React, { ReactNode } from 'react';

export interface SmallHeaderWithIconProps {
  icon: ReactNode;
  title: string;
  chipLabel?: string;
  chipColor?:
    | 'primary'
    | 'secondary'
    | 'success'
    | 'error'
    | 'info'
    | 'warning'
    | 'default';
  iconBackgroundColor?: string;
  iconSize?: string;
  children?: ReactNode;
}

const SmallHeaderWithIcon: React.FC<SmallHeaderWithIconProps> = ({
  icon,
  title,
  chipLabel,
  chipColor = 'primary',
  iconBackgroundColor = 'primary.main',
  iconSize = '1rem',
  children,
}) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2.5 }}>
      <Box
        sx={{
          backgroundColor: iconBackgroundColor,
          borderRadius: '50%',
          p: 0.5,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: 'white',
        }}
      >
        <Box sx={{ fontSize: iconSize, display: 'flex', alignItems: 'center' }}>
          {icon}
        </Box>
      </Box>
      <Box sx={{ flex: 1 }}>
        <Typography
          variant="h6"
          sx={{
            fontWeight: 700,
            color: 'text.primary',
            fontSize: '1rem',
            lineHeight: 1.1,
          }}
        >
          {title}
        </Typography>
        {chipLabel && (
          <Chip
            label={chipLabel}
            size="small"
            color={chipColor}
            variant="outlined"
            sx={{ height: '18px', fontSize: '0.65rem' }}
          />
        )}
      </Box>
      {children}
    </Box>
  );
};

export default SmallHeaderWithIcon;
